import { IParent } from 'app/shared/model/parent.model';
import { IClasse } from 'app/shared/model/classe.model';
import { ISupport } from './support.model';
import { IPointage } from './pointage.model';
import { IAbsence } from './absence.model';

export interface IEleve {
  id?: string;
  lastName?: string;
  firstName?: string;
  matricule?: string;
  birthdate?: string;
  telephone?: number;
  adresse?: string;
  classe?: IClasse | null;
  montantScolarite?: number;
  montantInscription?: number;
  inscriptionId?: string;
  statutPresence?: string;
  pointages?: IPointage[] | null;
  absences?: IAbsence[] | null;
  etatPaiement?: string;
  statutEnvoiFacture?: string;
  parent?: IParent | null;
  ecoleId?: string;
  anneeScolaireId?: string;
  support?: ISupport | null;
  photo?: string | null;
  page?: number;
  size?: number;
  file?: File;
  createInscription?: boolean;
  updateInscription?: boolean;
}
export enum statutEnvoiFacture {
  ACTIVE = 'ACTIVE',
  DESACTIVE = 'DESACTIVE',
}

export const defaultValue: Readonly<IEleve> = {
  id: null,
  lastName: '',
  firstName: '',
  matricule: '',
  statutPresence: null,
  telephone: null,
  adresse: '',
  classe: null,
  montantScolarite: 0,
  montantInscription: 0,
  inscriptionId: null,
  birthdate: '',
  etatPaiement: null,
  statutEnvoiFacture: null,
  pointages: null,
  absences: null,
  parent: null,
  support: null,
  ecoleId: '',
  anneeScolaireId: '',
  photo: '',
  file: null,
  page: 0,
  size: 0,
  createInscription: false,
  updateInscription: false,
};
